// osobni udaje - nepovinne oddily

function getFormId() {
    var form;
    form = document.getElementById('order-contact-details');
    if (!form) form = document.getElementById('registration');
    if (!form) form = document.getElementById('account-contact-details');
    return form.id;
}

var companyinfo = document.getElementById('companyinfo');
if (companyinfo !== null && typeof companyinfo === "object") {
    if (!companyinfo.checked) {
        var orderCompany = document.getElementById('order-company');
        if (orderCompany !== null) {
            orderCompany.style.display = 'none';
            companyinfo.setAttribute('aria-expanded', 'false');
        }
    } else {
        companyinfo.setAttribute('aria-expanded', 'true');
        ['company', 'ic'].forEach(function(item) {
            var element = document.getElementById(item);
            if (element) {
                element.classList.add('validate');
                element.required = true;
            }
        });
        optionalIdCountryCheck();
        conditionalIdNoCheck();
        checkForm(getFormId());
    }

    companyinfo.addEventListener('click', function () {
        var orderCompany = document.getElementById('order-company');
        if (orderCompany !== null) {
            var isVisible = this.checked;
            orderCompany.style.display = isVisible ? 'block' : 'none';
            companyinfo.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
        }
        ['company', 'ic'].forEach(function (item) {
            var element = document.getElementById(item);
            if (element) {
                if (element.classList.contains('validate')) {
                    element.classList.remove('validate');
                    element.removeAttribute('required');
                } else {
                    element.classList.add('validate');
                    element.required = true;
                    optionalIdCountryCheck();
                    conditionalIdNoCheck();
                }
            }
        });
        checkForm(getFormId(), 1);
        checkForm(getFormId());
    });
}
var deliveryinfo = document.getElementById('deliveryinfo');
if (deliveryinfo !== null && typeof deliveryinfo === 'object') {
    var deliveryAddress = document.getElementById('delivery-address'),
        telephoneDelivery = document.getElementById('telephone-delivery');

    if (deliveryAddress && telephoneDelivery) {
        if (!deliveryinfo.checked) {
            deliveryAddress.style.display = 'none';
            deliveryinfo.setAttribute('aria-expanded', 'false');
        } else {
            deliveryinfo.setAttribute('aria-expanded', 'true');
            telephoneDelivery.classList.add('validate');
            checkForm(getFormId());
        }

        deliveryinfo.addEventListener('click', function () {
            var isVisible = this.checked;
            deliveryAddress.style.display = isVisible ? 'block' : 'none';
            deliveryinfo.setAttribute('aria-expanded', isVisible ? 'true' : 'false');

            if (telephoneDelivery.classList.contains('validate')) {
                telephoneDelivery.classList.remove('validate');
            } else {
                telephoneDelivery.classList.add('validate');
            }

            checkForm(getFormId(), 1);
            checkForm(getFormId());
        });
    }
}
var register = document.getElementById('register');
if (register !== null && typeof register === 'object') {
    var registerBox = document.getElementById('register-box'),
        loginName = document.getElementById('login-name'),
        password = document.getElementById('password'),
        passwordConfirm = document.getElementById('passwordconfirm'),
        osobniUdaje = document.getElementById('osobni-udaje');

    if (registerBox && loginName && password && passwordConfirm && osobniUdaje) {
        if (!register.checked) {
            registerBox.style.display = 'none';
            register.setAttribute('aria-expanded', 'false');
        } else {
            register.setAttribute('aria-expanded', 'true');
            [loginName, password, passwordConfirm, osobniUdaje].forEach(function(element) {
                element.classList.add('validate');
                element.required = true;
            });
        }

        register.addEventListener('click', function() {
            var isVisible = this.checked;
            registerBox.style.display = isVisible ? 'block' : 'none';
            register.setAttribute('aria-expanded', isVisible ? 'true' : 'false');

            [loginName, password, passwordConfirm, osobniUdaje].forEach(function(element) {
                if (element.classList.contains('validate')) {
                    element.classList.remove('validate');
                    element.removeAttribute('required');
                } else {
                    element.classList.add('validate');
                    element.required = true;
                }
            });

            checkForm(getFormId(), 1);
            checkForm(getFormId());
        });
    }
}


// prida popisek volitelne u IC, pokud zeme jina nez CZ

function optionalIdCountryCheck() {
    var countryElement = document.getElementById('country'),
        countryVal = countryElement ? countryElement.value : null,
        icElement = document.getElementById('ic');
    if (countryVal == '40') {
        document.querySelectorAll('.optional--not-cz').forEach(function(elem) {
            elem.style.display = 'none';
        });
        if (document.getElementById('companyinfo').checked && icElement) {
            icElement.required = true;
        }
        document.querySelectorAll('.ares-lookup').forEach(function(elem) {
            elem.style.display = 'block';
        });
    } else {
        document.querySelectorAll('.optional--not-cz').forEach(function(elem) {
            elem.style.display = 'block';
        });
        if (icElement) {
            icElement.removeAttribute('required');
        }
        document.querySelectorAll('.ares-lookup').forEach(function(elem) {
            elem.style.display = 'none';
        });
    }
}


// skryje a deaktivuje pole IC, pokud zeme jina nez CZ nebo SK (ale nepouzije disabled, protoze je potreba v objednavce predat prazdnou hodnotu)

function conditionalIdNoCheck() {
    var countryElement = document.getElementById('country'),
        countryVal = countryElement ? countryElement.value : null,
        icElement = document.getElementById('ic');
    if (countryVal != '40' && countryVal != '196') {
        document.querySelectorAll('.form-row--cz-sk-only').forEach(function(elem) {
            elem.style.display = 'none';
        });
        if (icElement) {
            icElement.setAttribute('data-value', icElement.value);
            icElement.value = '';
        }
    } else {
        document.querySelectorAll('.form-row--cz-sk-only').forEach(function(elem) {
            elem.style.display = 'block';
        });
        if (icElement && icElement.value == '') {
            icElement.value = icElement.getAttribute('data-value') || '';
            icElement.setAttribute('data-value', '');
        }
    }
}

var countryElement = document.getElementById('country');
if (countryElement) { // Check if countryElement exists
    countryElement.addEventListener('change', function() {
        optionalIdCountryCheck();
        conditionalIdNoCheck();
        var closestForm = this.closest('form');
        if (closestForm) {
            checkForm(closestForm.id, 1);
        }
    });
}

optionalIdCountryCheck();
conditionalIdNoCheck();


// prida tridu .prev-step ke .step-boxu, ktery predchazi step-boxu, ktery je aktivni (.active) a soucasne posledni

var activeSteps = document.querySelectorAll('.active.step-box:last-child');
if (activeSteps.length > 0) {
    var prevStep = activeSteps[0].previousElementSibling;
    if (prevStep) {
        prevStep.classList.add('prev-step');
    }
}


// rizeni nabidky moznosti dopravy a platby

var paymentDeliveryElement = document.getElementById('payment-delivery');
if (paymentDeliveryElement) {
    setDeliveryPayment();
}


function analDeliveryPayment(type) {
    var val, value;
    if (type === 'delivery') {
        var deliveryTypeInputs = document.querySelectorAll('input[name="deliverytype"]:checked');
        if (deliveryTypeInputs.length > 0) {
            val = deliveryTypeInputs[0].value;
            value = document.querySelector('#delivery-' + val + ' .order-choice__name').textContent;
        }
    } else if (type === 'payment') {
        var paymentTypeInputs = document.querySelectorAll('input[name="paymenttype"]:checked');
        if (paymentTypeInputs.length > 0) {
            val = paymentTypeInputs[0].value;
            value = document.querySelector('#payment-' + val + ' .order-choice__name').textContent;
        }
    } else if (type === 'country') {
        value = document.querySelector('#dcountry option:checked').textContent;
    }

    dataLayer.push({
        ecommerce: null
    });
    dataLayer.push({
        'event': 'checkoutOption',
        'ecommerce': {
            'checkout_option': {
                'actionField': {
                    'step': '2',
                    'option': value || ''
                }
            }
        }
    });
}


function setDeliveryPaymentCountry() {
    var form = document.getElementById('payment-delivery'),
        stepInput = document.querySelector('input[name="step"]');
    if (stepInput) {
        stepInput.value = 'orderdeliverytype'; // hodnota pri loadu a hodnota aktulani - porovnat a submit jen kdyz se lisi
    }
    if (form) {
        form.submit();
    }
    return false;
}


function enableChoice(choice) {
    if (choice) {
        var orderChoices = document.querySelectorAll('#prow-' + choice + ' .order-choice'); // u hlavniho radku platby
        if (orderChoices) {
            orderChoices.forEach(function(element) {
                if (element && !element.classList.contains('order-choice--blocked')) { // jestli neni zakazano
                    element.classList.remove('order-choice--disabled'); // odeberme tridu
                }
            });
        }
        var orderNotes = document.querySelectorAll('#prow-' + choice + ' .order-note'); // v poznamce platby
        if (orderNotes) {
            orderNotes.forEach(function(element) {
                if (element && !element.classList.contains('order-note--blocked')) { // jestli neni zakazano
                    element.classList.remove('order-note--disabled'); // odeberme tridu
                }
            });
        }
        var pradioElement = document.getElementById('pradio-' + choice); // u inputu
        if (pradioElement) {
            var parentChoice = pradioElement.parentElement;
            if (parentChoice && !parentChoice.classList.contains('order-choice--blocked')) { // jestli neni zakazano
                pradioElement.removeAttribute('disabled'); // odeberme disabled
            }
        }
    }
}


function disableChoice(choice, pay) {
    if (choice) {
        var orderChoices = document.querySelectorAll('#prow-' + choice + ' .order-choice'); // u hlavniho radku platby
        if (orderChoices) {
            orderChoices.forEach(function(element) {
                if (element && !element.classList.contains('order-choice--disabled')) { // jestli uz tridu nema
                    element.classList.add('order-choice--disabled'); // tak ji pridejme
                }
            });
        }
        var orderNotes = document.querySelectorAll('#prow-' + choice + ' .order-note'); // v poznamce platby
        if (orderNotes) {
            orderNotes.forEach(function(element) {
                if (element && !element.classList.contains('order-note--disabled')) { // jestli uz tridu nema
                    element.classList.add('order-note--disabled'); // tak ji pridejme
                }
            });
        }
        var pradioElement = document.getElementById('pradio-' + choice); // u inputu
        if (pradioElement) {
            var parentChoice = pradioElement.parentElement;
            if (parentChoice && !parentChoice.classList.contains('order-choice--blocked')) { // jestli neni již zakazano
                pradioElement.setAttribute('disabled', 'disabled'); // nastavme input disabled
            }
        }
        if (pay === choice) { // pokud nastaven disabled na checked
            document.querySelector('input[name="paymenttype"]:enabled:first-of-type').checked = true; // hodme checked na prvni enabled shora
        }
    }
}


function setDeliveryPayment() {
    var delElement = document.querySelector('input[name="deliverytype"]:checked'),
        payElement = document.querySelector('input[name="paymenttype"]:checked');

    var del = delElement ? delElement.value : null,
        pay = payElement ? payElement.value : null;

    // UPS

    if (del === "2") {

        // (-) dobirka:         1
        disableChoice('1', pay);
        // (-) kartaonline:     5
        disableChoice('5', pay);
        // (-) prevodonline:    6
        disableChoice('6', pay);


    } else { // Jinak (když jinak než UPS)

        // (+) dobirka:         1
        enableChoice('1');
        // (+) kartaonline:     5
        enableChoice('5');
        // (+) prevodonline:    6
        enableChoice('6');

    }

    // Osobni odber

    if (del === "3") {

        // (+) hotovost: 4
        enableChoice('4');

        // (-) dobirka: 1
        disableChoice('1', pay);

    } else { // Jinak (když jinak než osobní odběr)

        // (-) hotovost: 4
        disableChoice('4', pay);

        if (del !== "2") { // pokud neni novou volbou UPS

            // (+) dobirka: 1
            enableChoice('1');

        }

    }

    var allChoices = document.querySelectorAll('.order-choice');
    if (allChoices) {
        allChoices.forEach(choice => {
            choice.removeAttribute('title'); // odebereme title ze vsech polozek
        });
    }
    var disabledChoices = document.querySelectorAll('.order-choice--disabled:not(.order-choice--blocked)'); // jestli disabled a neni zakazano
    if (disabledChoices) {
        disabledChoices.forEach(choice => {
            choice.setAttribute('title', choice.getAttribute('data-title-disabled')); // prehodime text z data- do title
        });
    }

    var deliveryTypeToCheck = Array.from(document.querySelectorAll('input[name="deliverytype"]')).find(input => input.checked && getComputedStyle(input).display !== 'none');
    var paymentTypeToCheck = Array.from(document.querySelectorAll('input[name="paymenttype"]')).find(input => input.checked && getComputedStyle(input).display !== 'none');

    if (!deliveryTypeToCheck) { // pokud zadna doprava checked
        var enabledDeliveryType = Array.from(document.querySelectorAll('input[name="deliverytype"]:enabled')).find(input => getComputedStyle(input).display !== 'none');
        if (enabledDeliveryType) {
            enabledDeliveryType.checked = true; // nastavime checked na te prvni
        }
    }

    if (!paymentTypeToCheck) { // pokud zadna platba checked
        var enabledPaymentType = Array.from(document.querySelectorAll('input[name="paymenttype"]:enabled')).find(input => getComputedStyle(input).display !== 'none');
        if (enabledPaymentType) {
            enabledPaymentType.checked = true; // nastavime checked na te prvni
        }
    }

    updatePrices();
}


// ARES Lookup on "Enter" Keydown Event

function checkAresEnter() {
    const ic = document.querySelector('#ic');
    if (ic) {
        const form = ic.closest('form');
        if (form) {
            const formId = form.id;
            ic.addEventListener('keydown', function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    aresLookup(formId);
                }
            });
        }
    }
}

checkAresEnter();